import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import FunzoneStyledQr from './FunzoneStyledQr';
import funzoneWordmark from '../../assets/logos/funzone-wordmark.png';

// Miniature of the printable A5 card, mirroring the PDF the backend renders:
// wordmark, headline, a large QR panel and the closing dash strip — no ordering
// steps, the flow is self-explanatory. It carries no location or table wording,
// exactly like the print product.
const CARD_INK = '#2C2E35';
const CARD_MUTED = '#7A7F8C';
const CARD_HAIRLINE = '#E6E8ED';
const CARD_DASHES = [
  '#FF5625',
  '#4DBE63',
  '#71D9EF',
  '#B6D443',
  '#948DC8',
  '#F2354E',
  '#FFE848',
  '#F03099',
  '#71D0B1',
];
const OrderCardPreview = ({ link }) => (
  <Box
    sx={{
      width: 200,
      // A5 portrait, like the printed card.
      aspectRatio: '148 / 210',
      bgcolor: '#FFFFFF',
      border: `1px solid ${CARD_HAIRLINE}`,
      borderRadius: 1.5,
      px: 1.5,
      py: 1.75,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      overflow: 'hidden',
    }}
  >
    <Box component='img' src={funzoneWordmark} alt='FunZone' sx={{ width: '58%' }} />

    <Box sx={{ textAlign: 'center' }}>
      <Typography sx={{ fontWeight: 900, fontSize: 21, lineHeight: 1.1, color: CARD_INK }}>
        Hungrig?
      </Typography>
      <Typography sx={{ fontSize: 6.5, color: CARD_MUTED }}>
        Bestell direkt von hier – ohne Anstehen.
      </Typography>
    </Box>

    <Box
      sx={{
        width: 150,
        border: `1px solid ${CARD_HAIRLINE}`,
        borderRadius: '14px',
        p: 2,
        bgcolor: '#FFFFFF',
      }}
    >
      <FunzoneStyledQr
        data={link}
        size={118}
        maxSize={118}
        margin={2}
        readyDelayMs={0}
        hideCenterLogo
        backgroundColor='#FFFFFF'
        moduleStyle='square'
        moduleColor={CARD_INK}
      />
    </Box>

    <Stack direction='row' spacing={0.4}>
      {CARD_DASHES.map(color => (
        <Box key={color} sx={{ width: 9, height: 3, borderRadius: 1.5, bgcolor: color }} />
      ))}
    </Stack>
  </Box>
);


export default OrderCardPreview;
